import { apiClient } from '@/api/client';
import type { ConversionReportRow, PipelineReportRow } from '@/types/shared';

export interface ConversionReportParams {
  /** Date-only (`YYYY-MM-DD`), inclusive window filtered by `leads.createdAt`. */
  from: string;
  to: string;
  /** Narrows to a single Sales Agent — optional, omit for every agent. */
  employeeId?: string;
}

/** GET /reports/sales/conversion — Roles: Admin, Sales Manager only. One row per Sales Agent with
 * leads assigned inside `[from, to]`. */
export async function getConversionReport(
  params: ConversionReportParams,
): Promise<ConversionReportRow[]> {
  const { data } = await apiClient.get<ConversionReportRow[]>('/reports/sales/conversion', {
    params,
  });
  return data;
}

/** GET /reports/sales/pipeline — Roles: Admin, Sales Manager only. Snapshot (no date range) of
 * currently-assigned, non-terminal leads grouped by employee + status. */
export async function getPipelineReport(): Promise<PipelineReportRow[]> {
  const { data } = await apiClient.get<PipelineReportRow[]>('/reports/sales/pipeline');
  return data;
}
